/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'organization-data-chart-scatter': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M18.75 18.75H2.5c-.69 0-1.25-.56-1.25-1.25V1.25H2.5V17.5h16.25v1.25zM6.25 15a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5zm2.5-4.375a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5zm5 0a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5zM16.25 5a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5zm-7.5 1.25a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5z"/>'
  }
})
